export default __webpack_public_path__ + "static/media/J.484e4760.png";